/**
 * Whether a share link would still be accepted (ADR 000133).
 *
 * The mirror of `domain.Share.Active`, which is the rule `ShareByToken` applies
 * before it serves anything: a revoked link and one past its expiry are both a
 * 404, and so is one that never existed. A surface that draws its own line
 * instead is a surface that can call a dead link live, which is what happened
 * to the share panel for as long as it filtered on revocation alone.
 *
 * Derived at read rather than carried as a field, the same as an asset's
 * abandoned upload. A stored answer is one more thing that can disagree with
 * the clock, and a link that runs out while somebody has the page open should
 * go quiet the next time the list is read.
 */
export function shareIsLive(share, now = new Date()) {
    if (share.revokedAt)
        return false;
    // Absent means it does not expire, not that it expired at the epoch.
    if (!share.expiresAt)
        return true;
    return now.getTime() < Date.parse(share.expiresAt);
}
//# sourceMappingURL=share.js.map